import React from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebaseConfig';

const UserInfo = ({ totalTestsTaken }) => {
  const [user] = useAuthState(auth);   //[firebase hook] to check if user is logged in or not destructure as array as useAuthState returns an array
  
  return(
    <div className="user-profile">
      <div className="user">
          <div className="picture">
            <AccountCircleIcon style={{display:'block', transform:'scale(6)', margin:'auto', marginTop: '3.5rem'}}/>
          </div>
          <div className="info">
            <div className="email">
              {user?.email}
            </div>
          <div className="joined-at">
            Joined on: {user?.metadata?.creationTime}
          </div>
          </div>
      </div>
      <div className="total-tests">
        Total Tests Taken: {totalTestsTaken}
      </div>
    </div>
  )
}
export default UserInfo;  